import React from 'react'
import PropTypes from 'prop-types'
import { DisplayExternalActivities } from 'components/DueDiligence/Questions'

import styles from './styles'

function BuildExternalActivityInfo(props) {
  const { externalActivities } = props
  const questionData = {
    items: externalActivities,
  }

  const classes = styles()

  return (
    <div className={classes.root}>
      <DisplayExternalActivities questionData={questionData} />
    </div>
  )
}

BuildExternalActivityInfo.propTypes = {
  externalActivities: PropTypes.arrayOf(
    PropTypes.shape({
      currently_at_this_job: PropTypes.bool,
      end_of_contract: PropTypes.string,
      start_working_hours: PropTypes.string,
      end_working_hours: PropTypes.string,
      investment_advisory_start_time: PropTypes.string,
      investment_advisory_end_time: PropTypes.string,
      role: PropTypes.string,
      developed_activities: PropTypes.string,
      bond_type: PropTypes.string,
      bond_informed_as_other: PropTypes.string,
      reports_to: PropTypes.string,
    }),
  ).isRequired,
}

export default BuildExternalActivityInfo
